import { render, staticRenderFns } from "./EditarEvento.vue?vue&type=template&id=d39762b4&scoped=true&"
import script from "./EditarEvento.vue?vue&type=script&lang=js&"
export * from "./EditarEvento.vue?vue&type=script&lang=js&"
import style0 from "./EditarEvento.vue?vue&type=style&index=0&id=d39762b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39762b4",
  null
  
)

export default component.exports